module.exports = __webpack_public_path__ + "img/upload-img.3cd39851.png";